import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CreateReceipt from './components/CreateReceipt';
import Admin from './components/Admin';
import Verify from './components/Verify';
import Navbar from './components/Navbar';
import Receipts from './components/Receipts';
import Profiles from './components/Profiles';
import ProductData from './components/ProductData';
import Profile from './components/Profile';
import About from './components/About';
import SuperAdmin from './components/SuperAdmin';
import { setOfflineScope } from './offlineDb';
import { syncPendingReceipts } from './offlineSync';
import './style.css';

function getUserFromToken(token) {
  if (!token) return null;

  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const user = getUserFromToken(token);

  useEffect(() => {
    setOfflineScope(user?.organization_id ? `${user.organization_id}:${user.id}` : user?.id || 'anonymous');
  }, [user?.id, user?.organization_id]);

  useEffect(() => {
    if (!token || user?.role !== 'buyer') return undefined;

    syncPendingReceipts(token);
    const onOnline = () => syncPendingReceipts(token);
    window.addEventListener('online', onOnline);
    return () => window.removeEventListener('online', onOnline);
  }, [token, user?.role]);

  return (
    <Router>
      <Navbar token={token} user={user} setToken={setToken} />
      <Routes>
        <Route path="/" element={<Login setToken={setToken} />} />
        <Route path="/dashboard" element={<Dashboard token={token} user={user} />} />
        <Route path="/create" element={<CreateReceipt token={token} />} />
        <Route path="/admin" element={<Admin token={token} />} />
        <Route path="/admin/profiles" element={<Profiles token={token} />} />
        <Route path="/superadmin" element={<SuperAdmin token={token} />} />
        <Route path="/receipts" element={<Receipts token={token} user={user} />} />
        <Route path="/product-data" element={<ProductData token={token} user={user} />} />
        <Route path="/profile" element={<Profile token={token} />} />
        <Route path="/about" element={<About />} />
        <Route path="/verify/:id" element={<Verify />} />
      </Routes>
    </Router>
  );
}
